module.exports = __webpack_public_path__ + "img/search-grey.5b821775.svg";